import { environment } from 'src/environments';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateSupportRequestModel } from 'app/core/models';

const basePath = `${environment.apiBaseUrl}support`;

@Injectable({ providedIn: 'root' })
export class SupportApiClient {
  private readonly _http = inject(HttpClient);

  /**
   * Submits a Contact Us inquiry. Success is 202 Accepted (no body); failures propagate to the
   * global HTTP error toast (errorInterceptor).
   */
  create(model: CreateSupportRequestModel): Observable<void> {
    const formData: FormData = new FormData();
    formData.append('name', model.name);
    formData.append('email', model.email);
    formData.append('subject', model.subject);
    formData.append('description', model.description);

    model.attachments.forEach((attachment: File): void => {
      formData.append('attachments', attachment, attachment.name);
    });

    return this._http.post<void>(`${basePath}/create`, formData);
  }
}
